import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, AlertCircle } from 'lucide-react';
import api from '../services/api';

function AdminMultaDetalle() {
  const [multa, setMulta] = useState(null);
  const [historial, setHistorial] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    const cargarDatos = async () => {
      try {
        const [multaRes, historialRes] = await Promise.all([
          api.get(`/multas/${id}`),
          api.get(`/multas/${id}/historial`),
        ]);

        if (multaRes.data.success === false) {
          setError('Multa no encontrada');
          return;
        }

        setMulta(multaRes.data.data);
        setHistorial(historialRes.data.data || []);
      } catch (err) {
        if (err.response?.status === 404) {
          setError('Multa no encontrada');
        } else {
          setError('Error al cargar los datos');
        }
      } finally {
        setLoading(false);
      }
    };

    cargarDatos();
  }, [id]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Cargando...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <AlertCircle className="w-12 h-12 text-red-500 mx-auto mb-4" />
          <p className="text-lg text-gray-900 mb-4">{error}</p>
          <button
            onClick={() => navigate('/admin/multas')}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
          >
            Volver a multas
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center gap-4">
          <button
            onClick={() => navigate(-1)}
            className="p-2 hover:bg-gray-100 rounded-lg"
          >
            <ArrowLeft className="w-6 h-6" />
          </button>
          <h1 className="text-2xl font-bold text-gray-900">
            Multa #{multa.numero_expediente}
          </h1>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Shell temporal - Phase 2 reemplazara con layout completo */}
        <pre className="bg-white rounded-xl shadow-sm p-6 overflow-auto text-sm">
          {JSON.stringify(multa, null, 2)}
        </pre>
      </main>
    </div>
  );
}

export default AdminMultaDetalle;
